import { render } from "./DeleteDocumentDialog.vue?vue&type=template&id=2afd6f74&scoped=true&ts=true&lang=pug"
import script from "./DeleteDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteDocumentDialog.vue?vue&type=script&lang=ts"

import "./DeleteDocumentDialog.vue?vue&type=style&index=0&id=2afd6f74&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afd6f74"]])

export default __exports__